import ellipsis from './ellipsis'
// 自定义指令
const directives = {
    ellipsis
}

export default {
    install(Vue) {
        Object.keys(directives).forEach((key) => {
            Vue.directive(key, directives[key])
        })
    },
}
